// Waits a given number of milliseconds whilst freeing up the thread
export default async (time: number): Promise<void> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return new Promise((resolve, _) => setTimeout(resolve, time));
};
